import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import gql from "graphql-tag";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import PageSpinner from "../../../components/elements/pageSpinner";
import { useAssetTypeQuery } from "../../../graphql/graphql";
import { getRoutePath } from "../../../router";
import Presenter from "./presenter";

interface AssetTypeEditPageProps {}

const AssetTypeEditPage: React.FC<AssetTypeEditPageProps> = () => {
  const { assetTypeId } = useParams();
  const { data } = useAssetTypeQuery({
    variables: { id: assetTypeId },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });
  const navigate = useNavigate();
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const onDrawerClose = () => {
    if (!data) return;
    onClose();
    setTimeout(() => {
      navigate(getRoutePath("assetCategories"));
    }, 500);
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onDrawerClose}>
      <DrawerOverlay>
        <DrawerContent>
          {data ? (
            <Presenter
              assetType={data.assetType}
              assetCategoryIconColor={data.assetType.assetCategory.iconColor}
              onDrawerClose={onDrawerClose}
            />
          ) : (
            <DrawerBody>
              <PageSpinner />
            </DrawerBody>
          )}
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default AssetTypeEditPage;

gql`
  query AssetType($id: UUID!) {
    assetType(id: $id) {
      ...AssetTypeWithRelationsFragment
    }
  }
`;
